import React from 'react';
import CompetitorsDashboard from './CompetitorsDashboard';

const CompeteDashboard: React.FC = () => {
  return <CompetitorsDashboard />;
};

export default CompeteDashboard;
